export const Categories = {
  Futebol : 39,
  OGlobo : 394,
} as const;

type CategoriesValuesType = typeof Categories[keyof typeof Categories];

export type { CategoriesValuesType };
